import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=35f6109a&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f6109a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f6109a')) {
      api.createRecord('35f6109a', component.options)
    } else {
      api.reload('35f6109a', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=35f6109a&scoped=true&", function () {
      api.rerender('35f6109a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2apPPIXoT8Ei5/JS/comp/Voucher-Unit.vue"
export default component.exports